export interface PrivacyLaw {
  id: string;
  name: string;
  category: 'global' | 'usFederal' | 'usState';
  description: string;
}

export const privacyLaws: PrivacyLaw[] = [
  // Global Privacy Laws
  {
    id: 'gdpr',
    name: 'GDPR (EU)',
    category: 'global',
    description: 'General Data Protection Regulation - Comprehensive data protection law in the EU'
  },
  {
    id: 'pipl',
    name: 'PIPL (China)',
    category: 'global',
    description: 'Personal Information Protection Law - China\'s data protection framework'
  },
  {
    id: 'lgpd',
    name: 'LGPD (Brazil)',
    category: 'global',
    description: 'Lei Geral de Proteção de Dados - Brazilian General Data Protection Law'
  },
  {
    id: 'pdpa_sg',
    name: 'PDPA (Singapore)',
    category: 'global',
    description: 'Personal Data Protection Act - Singapore\'s data protection framework'
  },
  {
    id: 'popia',
    name: 'POPIA (South Africa)',
    category: 'global',
    description: 'Protection of Personal Information Act - South Africa\'s privacy law'
  },

  // US Federal Laws
  {
    id: 'hipaa',
    name: 'HIPAA',
    category: 'usFederal',
    description: 'Health Insurance Portability and Accountability Act - Healthcare privacy'
  },
  {
    id: 'coppa',
    name: 'COPPA',
    category: 'usFederal',
    description: 'Children\'s Online Privacy Protection Act - Children\'s privacy online'
  },
  {
    id: 'glba',
    name: 'GLBA',
    category: 'usFederal',
    description: 'Gramm-Leach-Bliley Act - Financial privacy'
  },
  {
    id: 'fcra',
    name: 'FCRA',
    category: 'usFederal',
    description: 'Fair Credit Reporting Act - Consumer reporting privacy'
  },
  {
    id: 'ferpa',
    name: 'FERPA',
    category: 'usFederal',
    description: 'Family Educational Rights and Privacy Act - Educational privacy'
  },

  // US State Laws
  {
    id: 'ccpa',
    name: 'CCPA/CPRA (California)',
    category: 'usState',
    description: 'California Consumer Privacy Act/California Privacy Rights Act'
  },
  {
    id: 'vcdpa',
    name: 'VCDPA (Virginia)',
    category: 'usState',
    description: 'Virginia Consumer Data Protection Act'
  },
  {
    id: 'cpa',
    name: 'CPA (Colorado)',
    category: 'usState',
    description: 'Colorado Privacy Act'
  },
  {
    id: 'ctdpa',
    name: 'CTDPA (Connecticut)',
    category: 'usState',
    description: 'Connecticut Data Privacy Act'
  },
  {
    id: 'ucpa',
    name: 'UCPA (Utah)',
    category: 'usState',
    description: 'Utah Consumer Privacy Act'
  },
  { id: 'dpdpa', name: 'DPDPA (Delaware)', category: 'usState', description: 'Delaware Personal Data Privacy Act' },
  { id: 'incdpa', name: 'INCDPA (Indiana)', category: 'usState', description: 'Indiana Consumer Data Protection Act' },
  { id: 'icdpa', name: 'ICDPA (Iowa)', category: 'usState', description: 'Iowa Consumer Data Protection Act' },
  { id: 'kcdpa', name: 'KCDPA (Kentucky)', category: 'usState', description: 'Kentucky Consumer Data Protection Act' },
  { id: 'mpa', name: 'Maine Privacy Act', category: 'usState', description: 'Maine Privacy Act' },
  { id: 'modpa', name: 'MODPA (Maryland)', category: 'usState', description: 'Maryland Online Data Privacy Act' },
  { id: 'mpdpa', name: 'MPDPA (Michigan)', category: 'usState', description: 'Michigan Personal Data Privacy Act' },
  { id: 'mcdpa', name: 'MCDPA (Minnesota)', category: 'usState', description: 'Minnesota Consumer Data Privacy Act' },
  { id: 'mtcdpa', name: 'MTCDPA (Montana)', category: 'usState', description: 'Montana Consumer Data Privacy Act' },
  { id: 'ndpa', name: 'NDPA (Nebraska)', category: 'usState', description: 'Nebraska Data Privacy Act' },
  { id: 'nhpa', name: 'NHPA (New Hampshire)', category: 'usState', description: 'New Hampshire Data Privacy Act' },
  { id: 'njdpa', name: 'NJDPA (New Jersey)', category: 'usState', description: 'New Jersey Data Privacy Act' },
  { id: 'nypa', name: 'NYPA (New York)', category: 'usState', description: 'New York Privacy Act' },
  { id: 'dppa', name: 'DPPA (Nevada)', category: 'usState', description: 'Nevada Data Privacy Act' },
  { id: 'nccpa', name: 'NCCPA (North Carolina)', category: 'usState', description: 'North Carolina Consumer Data Privacy Act' },
  { id: 'ridtppa', name: 'RIDTPPA (Rhode Island)', category: 'usState', description: 'Rhode Island Digital Privacy Protection Act' },
  { id: 'ocpa', name: 'OCPA (Oregon)', category: 'usState', description: 'Oregon Consumer Privacy Act' },
  { id: 'tipa', name: 'TIPA (Tennessee)', category: 'usState', description: 'Tennessee Information Protection Act' }
];